$( document ).ready(function() {

  $(document).on('click', '.cartdu_add', function(e){
    e.preventDefault();
    var vid = $(this).parents('.cartdu_form').find('[name="id"]').val();
    var qty = $(this).parents('.cartdu_form').find('[name="quantity"]').val();
    addUpsellToCart(vid, qty);
  });
  function addUpsellToCart(uid, uqty) {
    data = {
      "id": uid,
      "quantity": uqty,
      "properties": {
        "_upsell": "yes"
      }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(data) { 
  
        //new theme.CartDrawer();
        
        document.dispatchEvent(new CustomEvent('cart:build'));
        
        $('.cartd_upsell_main').hide();
      },
      error: function(response){
        alert(response.responseJSON.description);
      }
    });
  }
  initial();
  function initial(){
    if (window.Flickity) {  
        setFlickity()
    } else {
        setTimeout(() => {
            initial()
        },500);
    }
  }
  
  function setFlickity(){
  var mediaQuery = window.matchMedia('(max-width: 768px)');
  if(mediaQuery.matches){
    if (document.querySelector('.carousel_on_mobile') ) {
      var flavour_caoursel = document.querySelector('.carousel_on_mobile');
      var flkty = new Flickity( flavour_caoursel, {
        contain: true,
        pageDots: false,
        prevNextButtons: false
      });
    };
  }
  }
  
});